// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__13Rt6","header":"MessagesList_header__KNGfo","chat":"MessagesList_chat__Rvh9Z"};